import React from "react";

import { Avatar } from "antd";
import { Divider, Dialog } from "@mui/material";

import Aptos from "../../asset/icons/Aptos.png";

export default function WithdrawModel(props: any) {
  const [amout, setAmount] = React.useState(0);
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={props.withdraw}
      onClose={() => props.setWithdraw(false)}
    >
      <div className="w-full bg-white rounded-xl px-10 py-16 flex flex-col items-center space-y-4">
        <span className="text-2xl text-text-dark-black font-semibold">
          Withdraw APT
        </span>
        <div className="flex flex-col w-full space-y-2">
          <span className="text-base text-text-dark-black font-semibold">
            Amount
          </span>
          <div className="flex flex-row items-center justify-between w-full bg-white shadow-md px-6 py-4 rounded-lg">
            <div className="flex flex-col items-start space-y-1">
              <input
                type="number"
                placeholder="0.00"
                step="any"
                value={amout}
                onChange={(e) => setAmount(parseFloat(e.target.value))}
                className="text-lg text-text-dark-black font-semibold border-none outline-none max-w-[100px]"
              />
              <span className="text-sm text-text-black font-medium">$0.00</span>
            </div>
            <div className="flex flex-col items-end space-y-1">
              <div className="flex flex-row items-center justify-center space-x-2">
                <Avatar src={Aptos} size="small" />
                <span className="text-lg text-text-dark-black font-semibold">
                  APT
                </span>
              </div>
              <span
                className="text-sm text-text-black font-medium cursor-pointer"
                onClick={() => setAmount(4.3)}
              >
                Balance: 4.30 MAX
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full space-y-2">
          <span className="text-base text-text-dark-black font-semibold">
            Transaction Overview
          </span>
          <div className="flex flex-col items-center justify-between w-full bg-white shadow-md px-6 py-4 rounded-lg">
            <div className="flex flex-row items-center justify-between w-full py-4">
              <span className="text-lg text-text-black font-medium">
                Remaining Supply
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                10.00 APT
              </span>
            </div>
            <Divider className="w-full" />
            <div className="flex flex-row items-center justify-between w-full py-4">
              <span className="text-lg text-text-black font-medium">
                Health Factor
              </span>
              <div className="flex flex-col items-end space-y-1">
                <span className="text-lg text-text-blur font-bold">1.78</span>
                <span className="text-sm text-text-black font-medium">
                  {"Liquidation at < 1.0"}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <input className="w-full bg-text-black rounded-full px-2 py-4 bg-opacity-30 text-white text-center"/> */}
        <button
          className="w-full text-center py-2 text-base font-bold text-white bg-text-blur rounded-full"
          onClick={() => props.setWithdraw(false)}
        >
          Withdraw
        </button>
      </div>
    </Dialog>
  );
}
